module.exports = __webpack_public_path__ + "media/images/lsbf_cover-f1fd22da1012b0f170001b4f9671730b.jpg";